<template>
  <v-card :flat="tarjetaPlana" :exact="tarjetaPlana">
    <v-card-title v-if="!tarjetaPlana">
      Datos personales
    </v-card-title>
    <v-card-text>
      <v-text-field
        label="Nombre"
        prepend-inner-icon="mdi-account"
        v-model="usuario.nombre"
        :rules="[
            () => !!usuario.nombre || 'Falta completar tu nombre',
            () => !!usuario.nombre && usuario.nombre.length <= 25 || 'Completá tu nombre hasta 25 caracteres'
          ]"
        outlined>
      </v-text-field>
      <v-row v-if="mostrarBloqueDireccion && isLoggedIn">
        <v-col cols="12" class="pb-1">
          <v-text-field
            v-if="!direccionesCuenta.length"
            v-model="usuario.direccion"
            readonly
            label="Dirección de entrega"
            :placeholder="usuario.direccion ? ' ' : 'Cargá una con «Nueva dirección» (abajo).'"
            :hint="verificandoZonaEntrega ? 'Comprobando cobertura de entrega…' : ''"
            persistent-hint
            outlined
            dense
            hide-details="auto"
            :rules="reglasDireccionEntregaCuenta"
            class="mb-2"
          />
          <v-select
            v-else
            v-model="selectedDireccionId"
            :items="direccionesCuentaItems"
            item-text="text"
            item-value="value"
            label="Dirección de entrega"
            prepend-inner-icon="mdi-map-marker"
            :hint="verificandoZonaEntrega ? 'Comprobando cobertura de entrega…' : ''"
            persistent-hint
            outlined
            hide-details="auto"
            :rules="reglasDireccionEntregaCuenta"
            @input="onCambioDireccionCuenta"
            class="mb-2"
          />
          <v-btn
            class="pl-0 mt-1"
            text
            small
            color="primary"
            @click="abrirNuevaDireccionDialogo"
          >
            <v-icon small left>mdi-plus</v-icon>
            Nueva dirección
          </v-btn>
        </v-col>
      </v-row>
      <v-row v-if="mostrarBloqueDireccion && !isLoggedIn">
        <v-col cols="9">
          <v-text-field
            label="Domicilio"
            prepend-inner-icon="mdi-map-marker"
            id="direccion"
            ref="direccion"
            @click:prepend-inner="onClickMapMarker"
            @click="onClickDireccion"
            v-model="usuario.direccion"
            :disabled="deshabilitarDomicilio"
            :readonly="clientData && clientData.UsarDeliveryPorZonas"
            :rules="[ ...reglasDomicilio ]"
            :hint="clientData && clientData.UsarDeliveryPorZonas ? 'Hacé clic aquí para seleccionar tu dirección en el mapa' : ''"
            persistent-hint
            outlined
          />
        </v-col>
        <v-col cols="3">
          <v-text-field
            label="Piso / Dpto."
            id="pisoDpto"
            ref="pisoDpto"
            v-model="usuario.pisoDpto"
            :disabled="deshabilitarDomicilio"
            placeholder="Opcional"
            outlined
          />
        </v-col>
      </v-row>
      <v-text-field
        label="Celular"
        :class="{ 'mt-8': mostrarBloqueDireccion && isLoggedIn }"
        :rules="[
            () => !!usuario.celular || 'Falta completar tu celular',
            () => !!usuario.celular && usuario.celular.length == 10 || 'Formato incorrecto',
            () => !!usuario.celular && !isNaN(usuario.celular) || 'Formato incorrecto'
          ]"
        prepend-inner-icon="mdi-cellphone"
        v-model="usuario.celular"
        placeholder="10 dígitos"
        outlined></v-text-field>

      <v-alert
        v-if="mostrarBloqueDireccion && !isLoggedIn && clientData && clientData.UsarDeliveryPorZonas && !usuario.direccion"
        type="info"
        dense
        outlined
        icon="mdi-information"
        class="mt-2"
      >
        <div class="d-flex align-center">
          <span class="text-caption">
            Hacé clic en el campo de dirección o en el ícono <v-icon x-small color="primary">mdi-map-marker</v-icon> para seleccionar tu domicilio en el mapa
          </span>
        </div>
      </v-alert>
    </v-card-text>
    <v-dialog ref="mapDialog" v-if="puedeAbrirMapaDomicilio" v-model="openMap"
        transition="dialog-bottom-transition"
        max-height="1024px"
        max-width="650px" persistent :fullscreen="$isMobile()">
      <GoogleMapSelector v-if="puedeAbrirMapaDomicilio && openMap" @cerrar-map-selector="openMap = false" @fuera-rango-entrega="domicilioFueraDeLasZonas = $event"/>
    </v-dialog>

    <v-dialog v-model="nuevaDireccionDialog" max-width="520" persistent :fullscreen="$isMobile()">
      <v-card>
        <v-card-title class="text-body-1">Nueva dirección</v-card-title>
        <v-card-text class="pt-4">
          <v-text-field
            v-model.trim="nuevaDireccionEditor.Alias"
            label="Alias (casa, trabajo…)"
            prepend-inner-icon="mdi-tag-outline"
            outlined
            dense
            hide-details="auto"
            class="mb-3"
          />
          <v-text-field
            v-model.trim="nuevaDireccionEditor.DireccionTexto"
            label="Dirección"
            prepend-inner-icon="mdi-map-marker"
            outlined
            dense
            hide-details="auto"
            class="mb-2"
            readonly
            :placeholder="(nuevaDireccionEditor.Lat != null && nuevaDireccionEditor.Lng != null) ? ' ' : 'Elegí la dirección en el mapa para geolocalizarla.'"
            :rules="[
              v => !!v || 'Elegí la dirección en el mapa',
              () => (nuevaDireccionEditor.Lat != null && nuevaDireccionEditor.Lng != null) || 'Falta geolocalizar la dirección (Lat/Lng)'
            ]"
            @click="abrirMapaNuevaDireccion"
          />
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="cerrarNuevaDireccionDialogo">
            Cancelar
          </v-btn>
          <v-spacer />
          <v-btn color="primary" :loading="nuevaDireccionGuardando" @click="guardarNuevaDireccionCuenta">
            Guardar y usar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="openMapNueva" fullscreen hide-overlay transition="dialog-bottom-transition">
      <GoogleMapSelector
        v-if="openMapNueva"
        omitir-validacion-zona
        @cerrar-map-selector="openMapNueva = false"
      />
    </v-dialog>
  </v-card>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import { bus } from '@/helpers/bus.js'
import GoogleMapSelector from './GoogleMapSelector.vue'
import { precioEnvioPorCoordenadas } from '@/helpers/zonaEnvioDesdeLatLng.js'

const DIRECCION_RETIRA = 'RETIRA EN SUCURSAL'
const GMAPS_GEOMETRY_TIMEOUT_MS = 15000

function googleMapsGeometryListo (g) {
  return !!(
    g && g.maps && g.maps.geometry && g.maps.geometry.poly
  )
}

export default {
  name: 'DatosPersonales',
  components: {
    GoogleMapSelector
  },
  computed: {
    ...mapGetters({
      clientData: 'App/data',
      isLoggedIn: 'Cuenta/isLoggedIn'
    }),
    reglasDomicilio () {
      if (!this.mostrarBloqueDireccion) return [() => true, () => true]
      return [
        () => !!this.usuario.direccion || 'Falta completar tu domicilio',
        () => {
          if (!this.clientData || !this.clientData.UsarDeliveryPorZonas) return true
          if (this.verificandoZonaEntrega) return true
          if (this.domicilioFueraDeLasZonas === true) {
            return 'No hacemos entregas en tu zona.'
          }
          return true
        }
      ]
    },
    /** Solo delivery: retira o paso sin elección aún no muestran el bloque de calle. */
    mostrarBloqueDireccion () {
      return this.formaEntrega === 1
    },
    direccionesCuenta () {
      const m = this.$store.state.Cuenta && this.$store.state.Cuenta.me
      if (!m || !m.Addresses || !m.Addresses.length) return []
      return Array.isArray(m.Addresses) ? m.Addresses : []
    },
    direccionesCuentaItems () {
      return (this.direccionesCuenta || []).map((a) => ({
        value: a.CliClienteDir_id,
        text: (a.Alias ? `${a.Alias} – ` : '') + (a.DireccionTexto || '')
      }))
    },
    puedeAbrirMapaDomicilio () {
      if (this.nuevaDireccionFlow || this.isLoggedIn) return false
      return this.clientData && this.clientData.UsarDeliveryPorZonas && this.formaEntrega === 1
    },
    reglasDireccionEntregaCuenta () {
      if (this.formaEntrega !== 1) {
        return [() => true]
      }
      const enZonaValidaOsinZonas = () => {
        if (!this.clientData || !this.clientData.UsarDeliveryPorZonas) return true
        if (this.verificandoZonaEntrega) return true
        if (this.domicilioFueraDeLasZonas === true) {
          return 'Esa dirección queda fuera de las zonas de entrega.'
        }
        return true
      }
      if (!this.direccionesCuenta.length) {
        return [
          () => {
            const d = this.usuario.direccion
            return (!!d && String(d).trim() && d !== DIRECCION_RETIRA) || 'Cargá una dirección con «Nueva dirección».'
          },
          enZonaValidaOsinZonas
        ]
      }
      return [
        () => (this.selectedDireccionId != null && this.selectedDireccionId !== '') || 'Elegí una dirección de entrega.',
        () => {
          const d = this.usuario.direccion
          return (!!d && String(d).trim() && d !== DIRECCION_RETIRA) || 'Elegí una dirección de entrega.'
        },
        enZonaValidaOsinZonas
      ]
    }
  },
  methods: {
    ...mapActions('Cuenta', ['fetchMe', 'saveCustomerAddress']),
    onClickMapMarker () {
      if (this.puedeAbrirMapaDomicilio) {
        this.openMap = true
        this.usuario.direccion = null
        this.domicilioFueraDeLasZonas = true
      }
    },
    onClickDireccion () {
      if (this.isLoggedIn) return
      if (this.clientData && this.clientData.UsarDeliveryPorZonas && this.formaEntrega === 1) {
        this.onClickMapMarker()
      }
    },
    /**
     * Si $gmapApiPromiseLazy nunca se resuelve, el await bloquea todo el recálculo
     * y el `finally` no baja "Comprobando cobertura...". Raza con timeout.
     */
    async asegurarGeometryMaps () {
      if (typeof window === 'undefined') return
      if (googleMapsGeometryListo(window.google)) return
      const fn = this.$gmapApiPromiseLazy
      if (typeof fn !== 'function') return
      const load = fn.call(this)
      if (!load || typeof load.then !== 'function') return
      try {
        const timeoutP = new Promise((resolve, reject) => {
          setTimeout(
            () => reject(new Error('GOOGLE_MAPS_LOAD_TIMEOUT')),
            GMAPS_GEOMETRY_TIMEOUT_MS
          )
        })
        await Promise.race([load, timeoutP])
      } catch (e) {
        if (e && e.message === 'GOOGLE_MAPS_LOAD_TIMEOUT') {
          // eslint-disable-next-line no-console
          console.warn('[DatosPersonales] Timeout o fallo carga del SDK de Google Maps para geometría.')
        } else {
          // eslint-disable-next-line no-console
          console.warn('[DatosPersonales] Error cargando Google Maps', e)
        }
      }
    },
    abrirNuevaDireccionDialogo () {
      this.nuevaDireccionDialog = true
      this.nuevaDireccionFlow = true
      this.nuevaDireccionEditor = {
        Alias: '',
        DireccionTexto: '',
        Lat: null,
        Lng: null,
        GoogleMapsUrl: null,
        EsPrincipal: this.direccionesCuenta.length === 0
      }
      // Siempre geolocalizable: abrir mapa para seleccionar/confirmar.
      this.openMapNueva = true
    },
    abrirMapaNuevaDireccion () {
      this.openMapNueva = true
    },
    cerrarNuevaDireccionDialogo () {
      this.nuevaDireccionDialog = false
      this.openMapNueva = false
      this.nuevaDireccionFlow = false
    },
    async guardarNuevaDireccionCuenta () {
      const t = (this.nuevaDireccionEditor && this.nuevaDireccionEditor.DireccionTexto) ? String(this.nuevaDireccionEditor.DireccionTexto).trim() : ''
      if (!t) return
      if (this.nuevaDireccionEditor.Lat == null || this.nuevaDireccionEditor.Lng == null) return
      const clientCode = this.$route && this.$route.params ? this.$route.params.client : null
      if (!clientCode) return
      this.nuevaDireccionGuardando = true
      try {
        const payload = {
          Alias: this.nuevaDireccionEditor.Alias || null,
          DireccionTexto: t,
          Lat: this.nuevaDireccionEditor.Lat,
          Lng: this.nuevaDireccionEditor.Lng,
          GoogleMapsUrl: this.nuevaDireccionEditor.GoogleMapsUrl || null,
          EsPrincipal: !!this.nuevaDireccionEditor.EsPrincipal
        }
        const me = await this.saveCustomerAddress({ clientCode, payload })
        this.cerrarNuevaDireccionDialogo()
        if (me && me.Addresses) {
          const byText = me.Addresses.find((a) => String(a.DireccionTexto || '').trim() === t)
          if (byText) {
            this.selectedDireccionId = byText.CliClienteDir_id
            this.aplicarDireccionDesdeCuenta(byText)
          } else {
            this.$nextTick(() => this.sincronizarDireccionSeleccionadaInicial())
          }
        }
        this.emitUsuarioActualizado()
      } finally {
        this.nuevaDireccionGuardando = false
      }
    },
    onCambioDireccionCuenta (id) {
      const sid = id == null ? '' : String(id)
      const a = (this.direccionesCuenta || []).find((x) => String(x.CliClienteDir_id) === sid)
      if (a) this.aplicarDireccionDesdeCuenta(a)
    },
    aplicarDireccionDesdeCuenta (a) {
      if (!a) return
      this.selectedDireccionId = a.CliClienteDir_id
      this.usuario.direccion = String(a.DireccionTexto || '').trim() || this.usuario.direccion
      this.usuario.googleMapsUrl = a.GoogleMapsUrl || null
      if (a.Lat != null && a.Lng != null) {
        const la = Number(a.Lat)
        const ln = Number(a.Lng)
        if (!Number.isNaN(la) && !Number.isNaN(ln)) {
          this.usuario.lat = la
          this.usuario.lng = ln
        } else {
          this.usuario.lat = null
          this.usuario.lng = null
        }
      } else {
        this.usuario.lat = null
        this.usuario.lng = null
      }
      if (this.clientData && this.clientData.UsarDeliveryPorZonas && this.formaEntrega === 1) {
        this.domicilioFueraDeLasZonas = null
      }
      this.recalcularEnvioSiCoordenadasEnZona().then(() => {
        this.emitUsuarioActualizado()
      })
    },
    normalizarCelular10 (telefono) {
      if (telefono == null || telefono === '') return null
      const digits = String(telefono).replace(/\D/g, '')
      if (digits.length >= 10) return digits.slice(-10)
      return String(telefono).trim()
    },
    sincronizarDireccionSeleccionadaInicial () {
      if (this.formaEntrega !== 1) return
      if (!this.direccionesCuenta.length) return
      if (this.selectedDireccionId) {
        const sel = String(this.selectedDireccionId)
        const a = this.direccionesCuenta.find((d) => String(d.CliClienteDir_id) === sel)
        if (a) {
          this.aplicarDireccionDesdeCuenta(a)
        }
        return
      }
      const principal = this.direccionesCuenta.find((a) => a.EsPrincipal) || this.direccionesCuenta[0]
      if (principal) this.aplicarDireccionDesdeCuenta(principal)
    },
    applyCustomerProfileFromMe (me) {
      if (!me) return
      if (me.ApellidoNombre) this.usuario.nombre = String(me.ApellidoNombre).trim()
      const cel = this.normalizarCelular10(me.Telefono)
      if (cel) this.usuario.celular = cel

      const principal = (me.Addresses && me.Addresses.length)
        ? (me.Addresses.find((a) => a.EsPrincipal) || me.Addresses[0])
        : null
      if (principal) {
        this.selectedDireccionId = principal.CliClienteDir_id
        if (principal.DireccionTexto) this.usuario.direccion = String(principal.DireccionTexto).trim()
        if (principal.GoogleMapsUrl) this.usuario.googleMapsUrl = principal.GoogleMapsUrl
        if (principal.Lat != null && principal.Lng != null) {
          const la = Number(principal.Lat)
          const ln = Number(principal.Lng)
          if (!Number.isNaN(la) && !Number.isNaN(ln)) {
            this.usuario.lat = la
            this.usuario.lng = ln
          }
        }
      } else if (me.Direccion) {
        this.selectedDireccionId = null
        this.usuario.direccion = String(me.Direccion).trim()
      }
    },
    async recalcularEnvioSiCoordenadasEnZona () {
      this.zonaEnVuelo = (this.zonaEnVuelo || 0) + 1
      this.verificandoZonaEntrega = true
      this.zonaRecalculoSecuencia = (this.zonaRecalculoSecuencia || 0) + 1
      const tokenZona = this.zonaRecalculoSecuencia
      try {
        if (!this.clientData || !this.clientData.UsarDeliveryPorZonas) {
          this.domicilioFueraDeLasZonas = false
          return
        }
        if (this.formaEntrega !== 1) {
          this.domicilioFueraDeLasZonas = false
          return
        }
        const lat = this.usuario.lat
        const lng = this.usuario.lng
        if (lat == null || lng == null) {
          if (this.usuario.direccion) {
            this.domicilioFueraDeLasZonas = true
          } else {
            this.domicilioFueraDeLasZonas = false
          }
          return
        }
        const res = await this.$store.dispatch('App/setZonasCliente')
        if (tokenZona !== this.zonaRecalculoSecuencia) return
        const zonasApi = res && res.data ? res.data : null
        if (!zonasApi || !zonasApi.length) {
          this.domicilioFueraDeLasZonas = false
          return
        }
        await this.asegurarGeometryMaps()
        if (tokenZona !== this.zonaRecalculoSecuencia) return
        if (!googleMapsGeometryListo(window.google)) {
          this.domicilioFueraDeLasZonas = false
          const def =
            (this.clientData && this.clientData.CostoEnvio) != null
              ? Number(this.clientData.CostoEnvio)
              : 0
          bus.$emit('nuevoCostoEnvio', def)
          // eslint-disable-next-line no-console
          console.warn(
            '[DatosPersonales] No hay geometría de Maps; se usa el costo de envío fijo de la tienda. Comprobá la clave/ API en .env (VUE_APP_GOOGLEAPIKEY) y en Google Cloud (Maps JavaScript + Geometry).'
          )
        } else {
          const g = window.google
          const { precio, enZona } = precioEnvioPorCoordenadas(zonasApi, lat, lng, g)
          if (tokenZona !== this.zonaRecalculoSecuencia) return
          if (enZona) {
            this.domicilioFueraDeLasZonas = false
            const costoZona = precio != null && !Number.isNaN(precio) ? precio : 0
            bus.$emit('nuevoCostoEnvio', costoZona)
          } else {
            this.domicilioFueraDeLasZonas = true
          }
        }
      } catch (e) {
        if (tokenZona === this.zonaRecalculoSecuencia) {
          this.domicilioFueraDeLasZonas = false
        }
      } finally {
        this.zonaEnVuelo = Math.max(0, (this.zonaEnVuelo || 0) - 1)
        this.verificandoZonaEntrega = (this.zonaEnVuelo || 0) > 0
      }
    },
    emitUsuarioActualizado () {
      this.$nextTick(() => {
        bus.$emit('onDataChangedBus', this.usuario)
      })
    },
    sincronizarFormaEntregaDesdeStore () {
      const f = this.$store.state.Checkout && this.$store.state.Checkout.formaEntrega
      if (f == null || f < 0) return
      if (this.formaEntrega === f) return
      this.aplicarFormaEntrega(f)
    },
    aplicarFormaEntrega (data) {
      this.formaEntrega = data
      if (data === 2) {
        if (this.usuario.direccion && this.usuario.direccion !== DIRECCION_RETIRA) {
          this.ultimaDireccion = this.usuario.direccion
        }
        this.usuario.direccion = DIRECCION_RETIRA
        this.usuario.pisoDpto = ''
        this.deshabilitarDomicilio = true
        this.domicilioFueraDeLasZonas = false
        this.openMap = false
        this.openMapNueva = false
        this.usuario.lat = null
        this.usuario.lng = null
        this.usuario.googleMapsUrl = null
        this.nuevaDireccionFlow = false
      } else {
        this.deshabilitarDomicilio = false
        this.openMap = false
        if (this.isLoggedIn && this.direccionesCuenta.length) {
          const sel = this.selectedDireccionId == null ? '' : String(this.selectedDireccionId)
          const fromSel = this.direccionesCuenta.find(
            (d) => String(d.CliClienteDir_id) === sel
          )
          const a = fromSel || this.direccionesCuenta.find((d) => d.EsPrincipal) || this.direccionesCuenta[0]
          if (a) this.aplicarDireccionDesdeCuenta(a)
          else {
            this.usuario.direccion = this.clientData && this.clientData.UsarDeliveryPorZonas
              ? null
              : this.ultimaDireccion
            this.domicilioFueraDeLasZonas = !!(this.clientData && this.clientData.UsarDeliveryPorZonas)
          }
        } else {
          const d =
            (this.ultimaDireccion != null) ? this.ultimaDireccion : this.usuario.direccion
          this.usuario.direccion = this.clientData && this.clientData.UsarDeliveryPorZonas
            ? null
            : d
        }
        this.$nextTick(() => {
          this.recalcularEnvioSiCoordenadasEnZona()
        })
      }
      this.emitUsuarioActualizado()
    }
  },
  props: {
    tarjetaPlana: {
      type: Boolean,
      default: true
    }
  },
  async created () {
    const clientCode = this.$route && this.$route.params ? this.$route.params.client : null

    this._onFormaEntregaChangedBus = (data) => {
      this.aplicarFormaEntrega(data)
    }
    bus.$on('onFormaEntregaChangedBus', this._onFormaEntregaChangedBus)
    this._onDomicilioGoogleMapSelectorChange = (d) => {
      if (this.nuevaDireccionFlow) {
        if (typeof d === 'string' && d) {
          this.nuevaDireccionEditor.DireccionTexto = d
        }
        return
      }
      this.usuario.direccion = d
    }
    bus.$on('onDomicilioGoogleMapSelectorChange', this._onDomicilioGoogleMapSelectorChange)
    this._onGoogleMapsUrlChange = (d) => {
      if (this.nuevaDireccionFlow) {
        if (typeof d === 'string' && d) {
          this.nuevaDireccionEditor.GoogleMapsUrl = d
        }
        return
      }
      this.usuario.googleMapsUrl = d
    }
    bus.$on('onGoogleMapsUrlChange', this._onGoogleMapsUrlChange)
    this._onGoogleMapsLatLngChange = (data) => {
      if (this.nuevaDireccionFlow) {
        if (data) {
          this.nuevaDireccionEditor.Lat = data.lat
          this.nuevaDireccionEditor.Lng = data.lng
        }
        return
      }
      if (!data) return
      this.usuario.lat = data.lat
      this.usuario.lng = data.lng
    }
    bus.$on('onGoogleMapsLatLngChange', this._onGoogleMapsLatLngChange)

    if (this.isLoggedIn && clientCode) {
      try {
        const me = await this.$store.dispatch('Cuenta/fetchMe', { clientCode })
        if (me) {
          this.applyCustomerProfileFromMe(me)
          await this.recalcularEnvioSiCoordenadasEnZona()
        }
        this.sincronizarFormaEntregaDesdeStore()
        this.sincronizarDireccionSeleccionadaInicial()
        this.emitUsuarioActualizado()
      } catch (e) {
        this.sincronizarFormaEntregaDesdeStore()
      }
      this.$nextTick(() => {
        this.sincronizarFormaEntregaDesdeStore()
      })
      return
    }

    if (this.$cookies.isKey('info')) {
      const info = this.$cookies.get('info')
      this.usuario.nombre = this.$CryptoJS.AES.decrypt(
        info.name,
        process.env.VUE_APP_SECRET_PHRASE
      ).toString(this.CryptoJS.enc.Utf8)
      this.usuario.direccion = this.$CryptoJS.AES.decrypt(
        info.address,
        process.env.VUE_APP_SECRET_PHRASE
      ).toString(this.CryptoJS.enc.Utf8)
      this.usuario.celular = this.$CryptoJS.AES.decrypt(
        info.phone,
        process.env.VUE_APP_SECRET_PHRASE
      ).toString(this.CryptoJS.enc.Utf8)
      this.observaciones = this.$CryptoJS.AES.decrypt(
        info.obs,
        process.env.VUE_APP_SECRET_PHRASE
      ).toString(this.CryptoJS.enc.Utf8)
      this.sincronizarFormaEntregaDesdeStore()
      this.$nextTick(() => this.sincronizarFormaEntregaDesdeStore())
      this.emitUsuarioActualizado()
      return
    }

    try {
      if (clientCode) {
        const me = await this.$store.dispatch('Cuenta/fetchMe', { clientCode })
        if (me) {
          if (!this.usuario.nombre && me.ApellidoNombre) this.usuario.nombre = me.ApellidoNombre
          if (!this.usuario.celular && me.Telefono) this.usuario.celular = this.normalizarCelular10(me.Telefono)
          if (!this.usuario.direccion && me.Direccion) this.usuario.direccion = me.Direccion
          this.emitUsuarioActualizado()
        }
      }
    } catch (e) {
      // invitado: ignorar
    }
    this.sincronizarFormaEntregaDesdeStore()
    this.$nextTick(() => this.sincronizarFormaEntregaDesdeStore())
  },
  mounted () {
    this.sincronizarFormaEntregaDesdeStore()
  },
  beforeDestroy () {
    if (this._onFormaEntregaChangedBus) bus.$off('onFormaEntregaChangedBus', this._onFormaEntregaChangedBus)
    if (this._onDomicilioGoogleMapSelectorChange) bus.$off('onDomicilioGoogleMapSelectorChange', this._onDomicilioGoogleMapSelectorChange)
    if (this._onGoogleMapsUrlChange) bus.$off('onGoogleMapsUrlChange', this._onGoogleMapsUrlChange)
    if (this._onGoogleMapsLatLngChange) bus.$off('onGoogleMapsLatLngChange', this._onGoogleMapsLatLngChange)
  },
  data () {
    return {
      ultimaDireccion: null,
      selectedDireccionId: null,
      nuevaDireccionDialog: false,
      openMapNueva: false,
      nuevaDireccionFlow: false,
      nuevaDireccionGuardando: false,
      nuevaDireccionEditor: {
        Alias: '',
        DireccionTexto: '',
        Lat: null,
        Lng: null,
        GoogleMapsUrl: null,
        EsPrincipal: false
      },
      usuario: {
        nombre: null,
        celular: null,
        direccion: null,
        pisoDpto: '',
        googleMapsUrl: null,
        lat: null,
        lng: null
      },
      openMap: false,
      domicilioFueraDeLasZonas: null,
      verificandoZonaEntrega: false,
      zonaRecalculoSecuencia: 0,
      zonaEnVuelo: 0,
      deshabilitarDomicilio: false,
      formaEntrega: -1
    }
  },
  watch: {
    'usuario.nombre' () {
      bus.$emit('onDataChangedBus', this.usuario)
    },
    'usuario.direccion' () {
      bus.$emit('onDataChangedBus', this.usuario)
    },
    'usuario.celular' () {
      bus.$emit('onDataChangedBus', this.usuario)
    },
    'usuario.pisoDpto' () {
      bus.$emit('onDataChangedBus', this.usuario)
    },
    'usuario.googleMapsUrl' () {
      bus.$emit('onDataChangedBus', this.usuario)
    },
    'usuario.lat' () {
      bus.$emit('onDataChangedBus', this.usuario)
    },
    'usuario.lng' () {
      bus.$emit('onDataChangedBus', this.usuario)
    }
  }
}
</script>
